export default __webpack_public_path__ + "static/media/music_disabled.9d2ee99d.svg";